export const GANTT_AUTO_SCHEDULE_STORAGE_KEY = 'gantt:autoScheduleEnabled';

export const GANTT_AUTO_SCHEDULE_CHANGED_EVENT = 'gantt:autoScheduleChanged';

const LIVE_SCHEDULE_OFF_MODAL_SKIP_KEY = 'falcon-planner:gantt-live-schedule-off-modal-skip';

export function readAutoSchedulePreference(): boolean {
  if (typeof window === 'undefined') return true;
  return window.localStorage.getItem(GANTT_AUTO_SCHEDULE_STORAGE_KEY) !== '0';
}

export function writeAutoSchedulePreference(enabled: boolean): void {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(GANTT_AUTO_SCHEDULE_STORAGE_KEY, enabled ? '1' : '0');
  window.dispatchEvent(
    new CustomEvent(GANTT_AUTO_SCHEDULE_CHANGED_EVENT, { detail: { enabled } })
  );
}

/** Session-only: skip the "Live Schedule is off" dialog after Don't ask again. */
export function readLiveScheduleOffModalSkipPreference(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    const raw = window.sessionStorage.getItem(LIVE_SCHEDULE_OFF_MODAL_SKIP_KEY);
    return raw === '1' || raw === 'true';
  } catch {
    return false;
  }
}

export function writeLiveScheduleOffModalSkipPreference(skip: boolean): void {
  if (typeof window === 'undefined') return;
  try {
    if (skip) {
      window.sessionStorage.setItem(LIVE_SCHEDULE_OFF_MODAL_SKIP_KEY, '1');
    } else {
      window.sessionStorage.removeItem(LIVE_SCHEDULE_OFF_MODAL_SKIP_KEY);
    }
  } catch {
    // ignore quota / private mode
  }
}
